export default __webpack_public_path__ + "static/tetiana-hutii-276d013e9dde76f9ca97cc674c8fad5f.png";